import { useState, useEffect } from "react";
import ListingCard from "../components/ListingCard";
import FiltersSidebar from "../components/FiltersSidebar";

import ResultsTitle from "../components/ResultsTitle";

import { useVehicle }
from "../context/VehicleContext";

function SearchResultsPage() {

const params = new URLSearchParams(window.location.search);
const query = (params.get("q") || "").toLowerCase();
const [parts, setParts] = useState([]);

const {
  selectedVehicle,
  vehicleLoaded,
} = useVehicle();


useEffect(() => {

if (!vehicleLoaded) return;

  const fetchListings = async () => {

    try {

      let url =
        `https://eleven11-i6v4.onrender.com/api/listings/search/query?q=${encodeURIComponent(query)}`;

      if (selectedVehicle) {

        const params =
          new URLSearchParams({

            manufacturer:
              selectedVehicle.manufacturer,

            model:
              selectedVehicle.model,

            year:
              selectedVehicle.year,

          });

        url += `&${params.toString()}`;
      }

      const res = await fetch(url);

      const data = await res.json();

      setParts(data);

    } catch (err) {

      console.error(
        "Error loading listings:",
        err
      );

    }

  };

  fetchListings();

}, [query, selectedVehicle, vehicleLoaded]);


  return (
    <div style={styles.page}>



{/* HEADER */}
<div style={styles.header}>
  <div style={styles.logo}>Search Results</div>
  <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginTop: 4 }}>
    <div style={styles.search}>Showing results for "{query}"</div>
    {selectedVehicle && (
      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#EEF2FF", border: "1px solid rgba(90,142,252,0.2)", borderRadius: 999, padding: "4px 12px" }}>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#3157b7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#3157b7" }}>
          {selectedVehicle.year} {selectedVehicle.manufacturer} {selectedVehicle.model}
        </span>
      </div>
    )}
  </div>
</div>



      {/* MAIN */}
      <div style={styles.main}>

       <FiltersSidebar />


        {/* RESULTS */}



        <div style={styles.results}>
    <div style={styles.resultsIntro}>

  <div style={styles.resultsLabel}>
    Results
  </div>

<div style={styles.resultsSub}>
  {parts.length} result{parts.length !== 1 ? "s" : ""} for "{query}"
  {selectedVehicle && ` · ${selectedVehicle.year} ${selectedVehicle.manufacturer} ${selectedVehicle.model}`}
</div>


</div>
       
{parts.map((part) => (
  <ListingCard key={part._id} part={part} />
))}
        </div>

      </div>

    </div>
  );
}

export default SearchResultsPage;


const styles = {
page: {
  minHeight: "100vh",
  background: "linear-gradient(to bottom, #F6F7FB, #F3F5FA)"
},

  header: {
    padding: "20px 40px",
    borderBottom: "1px solid #e5e5e5",
    fontFamily: "-apple-system, BlinkMacSystemFont, system-ui"
  },

  logo: {
    fontSize: 22,
    fontWeight: 600,
    marginBottom: 4
  },

  search: {
    fontSize: 14,
    color: "#6e6e73"
  },


resultsHeader: {
  marginBottom: 20
},

resultsList: {
  display: "flex",
  flexDirection: "column",
  gap: 20
},

  main: {
  display: "grid",
  gridTemplateColumns: "260px 1fr",
  gap: 90,

  maxWidth: 1350,

  marginLeft: 40,
  marginTop: 40
},

 resultsIntro:{
  marginBottom: 8,
},

resultsLabel:{
  fontSize: 30,
  fontWeight: 600,
  letterSpacing: "-1.8px",
  color: "#111111",
  marginBottom: 6,
},

resultsSub:{
  fontSize: 15,
  color: "#8E8E93",
  fontWeight: 500,
},

results: {
  display: "flex",
  flexDirection: "column",
  gap: 24,
  paddingLeft: 10,
}
};